<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm10>
        <v-layout wrap>
          <v-flex xs12 text-center>
            <h1>{{ $t('a') }}</h1>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-2 mb-2 justify-center>
          <v-flex xs12 text-center>
            <img :src="images.top" height="250px"/>
          </v-flex>
          <v-flex xs6>
            <v-layout wrap>
              <v-flex xs12>
                <div v-if="isFetchingCompanies || isJoiningCompany">
                  <v-progress-linear indeterminate color="primary"></v-progress-linear>
                </div>
                <div v-else>
                  <v-layout wrap>
                    <v-flex xs12 v-for="(company, key) in companies" :key="key">
                      <onboarding-choosable-company
                        :company="company"
                        @refreshCompanies="getCompaniesWithMyEmailDomain"
                        @setIsJoiningCompany="setIsJoiningCompany"
                      />
                    </v-flex>
                    <v-flex xs12 class="mt-12 mb-10" text-center>
                      <small>
                        <div><b>{{ $t('c') }}</b></div>
                        <div>{{ $t('d') }} <a href="mailto:martin@esnwebservices.com">martin@esnwebservices.com</a></div>
                      </small>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
                
    
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OnboardingChoosableCompany from '@/components/OnboardingChoosableCompany'

export default {
  components: {
    OnboardingChoosableCompany
  },
  data: () => ({
    selectedCompanyId: null,
    companies: [],
    isFetchingCompanies: false,
    images: {
      top: require('@/assets/app/images/world_2.svg'),
    },
    isJoiningCompany: false
  }),
  async mounted() {
    await this.getCompaniesWithMyEmailDomain()
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    userCompanyId() {
      return this.user.data.companyId
    }
  },
  methods: {
    async getCompaniesWithMyEmailDomain() {
      this.isFetchingCompanies = true
      this.companies = (await this.$functions.httpsCallable('getCompaniesWithMyEmailDomain')()).data
      this.isFetchingCompanies = false
    },
    setIsJoiningCompany(isJoiningCompany) {
      this.isJoiningCompany = isJoiningCompany
    }
  },
  watch: {
    userCompanyId: {
      handler() {
        if (this.userCompanyId) {
          return this.$router.push('/dossiers/create')
        }
      }
    }
  }
}
</script>

<i18n>
{
  "fr": {
    "a": "Choisissez votre équipe",
    "c": "Vous souhaitez créer une autre équipe ?",
    "d": "Contactez-nous à"
  },
  "en": {
    "a": "Choose your team",
    "b": "Choose",
    "c": "You want to create a new team ?",
    "d": "Contact us at"
  }
}
</i18n>